/**
 * 260807nrai: DevHosts become-user without a persistent <form> in the header.
 * Legacy pages use document.forms[0]; a header form would steal that index.
 */

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : null;
}

/**
 * Full-page POST to become_user (same navigation as the old form submit).
 *
 * @param {string} url
 * @param {string} username
 */
function postBecomeUser(url, username) {
  if (!url || !username) return;

  const form = document.createElement('form');
  form.method = 'post';
  form.action = url;
  form.style.display = 'none';

  const token = csrfToken();
  if (token) {
    const authenticity = document.createElement('input');
    authenticity.type = 'hidden';
    authenticity.name = 'authenticity_token';
    authenticity.value = token;
    form.appendChild(authenticity);
  }

  const usernameField = document.createElement('input');
  usernameField.type = 'hidden';
  usernameField.name = 'username';
  usernameField.value = username;
  form.appendChild(usernameField);

  document.body.appendChild(form);
  form.submit();
}

function becomeUrlFrom(el) {
  const root = el && el.closest('.header_user_become');
  return root ? root.getAttribute('data-become-url') : null;
}

/**
 * Bind click/Enter handlers for header become controls (desktop + mobile).
 *
 * Click uses the capture phase so Foundation topbar's
 * stopImmediatePropagation on li.has-dropdown (touch / non-hover)
 * cannot swallow the orange-arrow / back-link click before document bubble.
 *
 * @note **Callers (typical):** `custom/index.js` on DOMContentLoaded
 */
export function initHeaderBecomeUser() {
  // 260812nrai: capture — Foundation topbar stops bubble inside user dropdown
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const submitButton = target.closest('.header_user_become_submit');
    if (submitButton) {
      event.preventDefault();
      event.stopPropagation();
      const root = submitButton.closest('.header_user_become');
      const input = root && root.querySelector('.header_user_become_input');
      const username = input && input.value.trim();
      if (!username) {
        if (input) input.focus();
        return;
      }
      postBecomeUser(becomeUrlFrom(submitButton), username);
      return;
    }

    const recentItem = target.closest('.header_user_become_recent_item');
    if (recentItem) {
      event.preventDefault();
      event.stopPropagation();
      const username = (recentItem.getAttribute('data-username') || '').trim();
      postBecomeUser(becomeUrlFrom(recentItem), username);
      return;
    }

    const backButton = target.closest('.header_user_become_back_link');
    if (backButton) {
      event.preventDefault();
      event.stopPropagation();
      const username = (backButton.getAttribute('data-username') || '').trim();
      postBecomeUser(becomeUrlFrom(backButton), username);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const input = target.closest('.header_user_become_input');
    if (!input) return;
    event.preventDefault();
    const username = input.value.trim();
    if (!username) return;
    postBecomeUser(becomeUrlFrom(input), username);
  });

  // 260902nrai: show last signed-in-as employees when the become field is focused
  document.querySelectorAll('.header_user_become').forEach(bindRecentList);
}

/**
 * Show / filter the recent become-user list on the given header control.
 *
 * @param {Element} root
 */
function bindRecentList(root) {
  const input = root.querySelector('.header_user_become_input');
  const list = root.querySelector('.header_user_become_recent');
  if (!input || !list) return;

  const items = () => list.querySelectorAll('.header_user_become_recent_item');

  const filterItems = () => {
    const query = input.value.trim().toLowerCase();
    let visibleCount = 0;
    items().forEach((item) => {
      const hay = (item.getAttribute('data-search') || item.textContent || '').toLowerCase();
      const match = !query || hay.indexOf(query) !== -1;
      item.classList.toggle('is-filtered', !match);
      if (match) visibleCount += 1;
    });
    return visibleCount;
  };

  const showList = () => {
    if (filterItems() > 0) {
      list.classList.add('is-open');
      root.classList.add('is-suggesting');
    } else {
      hideList();
    }
  };

  const hideList = () => {
    list.classList.remove('is-open');
    root.classList.remove('is-suggesting');
  };

  input.addEventListener('focus', showList);
  input.addEventListener('click', (event) => {
    event.stopPropagation();
    showList();
  });
  input.addEventListener('input', showList);
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hideList();
  });
  input.addEventListener('blur', () => {
    window.setTimeout(hideList, 150);
  });
  list.addEventListener('mousedown', (event) => {
    event.preventDefault();
  });
}
